module.exports = __webpack_public_path__ + "static/media/funitygame.10954084.png";